import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Grid, Segment, List, Button, Divider, Responsive } from 'semantic-ui-react';
import {compact, intersection} from 'lodash';
import ItemIcon from '../../common/ItemIcon';
import ModelViewer from '../../common/model-viewer/ModelViewer';
import PagedItemView from '../../common/items/PagedItemView';
import Model from '../../common/model-viewer/Model';
import ItemFilterForm from '../../common/items/ItemFilterForm';

class AppearanceDetailComponent extends Component {
    constructor() {
        super();

        this.state = {
            icon: 'expand',
            modelColumns: 6,
            itemColumns: 10,
            items: [],
        };
    }

    onExpandClick = () => {
        const {icon} = this.state;

        if(icon === 'expand') {
            this.setState({
                icon: 'compress',
                modelColumns: 11,
                itemColumns: 5,
            });
        } else {
            this.setState({
                icon: 'expand',
                modelColumns: 6,
                itemColumns: 10,
            });
        }
    }

    componentDidMount() {
        this.setState({
            items: this.props.appearance.Items,
        });
    }

    onFilterChange = (tags) => {

        const {Items} = this.props.appearance;

        const filteredItems = tags === [] ?
            Items :
            compact( Items.map( i => intersection( i.Tags, tags ).length === tags.length ? i : null ) );

        this.setState({
            items: filteredItems,
        });
    }

    render() {
        const {appearance} = this.props;
        const {items, icon, modelColumns, itemColumns} = this.state;

        const model = new Model({appearance: appearance});

        return (
            <List divided>
                <Header as='h1' icon textAlign='center'>
                    <ItemIcon image={appearance.Icon} circular />
                    <Header.Content>{appearance.Name.English}</Header.Content>
                    <Header.Subheader>{appearance.Type} {appearance.Slot}</Header.Subheader>
                </Header>
                <Divider section/>
                <Grid stackable columns="2">
                    <Grid.Row>
                        <Grid.Column width={modelColumns}>
                            <Segment.Group>
                                <Segment attached='top' clearing>
                                    <Header as='h3'>
                                        Model
                                        <Responsive as={
                                            () => <Button icon={icon} floated='right' basic onClick={this.onExpandClick}/>
                                        } {...Responsive.onlyComputer} />
                                    </Header>
                                </Segment>
                                <Segment>
                                    <ModelViewer appearanceId={appearance.Id} model={model} />
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                        <Grid.Column width={itemColumns}>
                            <Segment.Group>
                                <Segment attached='bottom'>
                                    <Header as='h3'>
                                        Items using appearance
                                    </Header>
                                </Segment>
                                <Segment attached='top'>
                                    <ItemFilterForm items={appearance.Items} onFilterChange={this.onFilterChange} filter={['Bind on Equip', 'Quest Reward', 'Purchasable', 'Craftable']} />
                                    <PagedItemView items={items} />
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </List>
        );
    }
}


const mapStateToProps = state => ({
    appearance: state.appearanceState.appearance,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps())(AppearanceDetailComponent);



// WEBPACK FOOTER //
// ./src/appearances/detail/AppearanceDetailComponent.jsx